export const DEFAULT_LOAN_TERM = 30
export const DEFAULT_CREDIT_SCORE = 700
export const NATIONAL_AVG_DOWN_PAYMENT = 0.07
export const NATIONAL_AVG_MONTHLY_HOME_INSURANCE = 194
export const NATIONAL_AVG_MONTHLY_PROPERTY_TAX_RATE = 0.009
export const RATES_OFFSETS = {
  '620': 0.0125,
  '640': 0.01,
  '660': 0.0075,
  '680': 0.0075,
  '700': 0.0025,
  '720': 0.0025,
  '740': -0.00125,
  '800': -0.00125
}

// PMI Rates segmented by LTV and credit score
// Each array is 8 numbers long, going from the
// lowest credit band to the highest
// Rates pulled from https://www.mgic.com/-/media/mi/rates/rate-cards/71-61284-rate-card-pdf-bpmi-monthly-july-2018.pdf
export const HIGH_LTV_PMI_RATES = [0.0186, 0.0165, 0.0154, 0.0121, 0.0099, 0.0087, 0.007, 0.0058]
export const MEDIUM_HIGH_LTV_PMI_RATES = [0.0142, 0.0133, 0.0128, 0.0096, 0.0078, 0.0066, 0.0053, 0.0038]
export const MEDIUM_LOW_LTV_PMI_RATES = [0.0094, 0.0091, 0.009, 0.0065, 0.0055, 0.0046, 0.0038, 0.0028]
export const LOW_LTV_PMI_RATES = [0.0044, 0.004, 0.0038, 0.0028, 0.0025, 0.0023, 0.002, 0.0019]
// Array holding the start of all of the credit bands for above PMI rates
export const PMI_CREDIT_BANDS = [620, 640, 660, 680, 700, 720, 740, 760]

// loans with a LTV above this threshold will require PMI
// this is the threshold for conventional loans
export const PMI_THRESHOLD = 0.8 // 80%
